import { inject, Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { catchError, map, of, switchMap } from "rxjs";
import { CommonApiService } from "src/app/services/common-api.service";
import { API } from "src/app/common/models/api.enum";
import { decryptData } from "src/app/common/functions/crypto.functions";
import {
  copyLanguage,
  copyLanguageFailed,
  copyLanguageSuccess,
} from "./copy-language.actions";
import { AlertService } from "src/app/services/alert.service";

@Injectable()
export class CopyLanguageEffects {
  private actions$ = inject(Actions);
  private commonApiService = inject(CommonApiService);
  private alertService = inject(AlertService);

  copyLanguage$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(copyLanguage),
      switchMap((action) => {
        const id = this.agentId();
        if (!id) {
          return of(copyLanguageFailed({ error: "Invalid Bot ID" }));
        }

        const fullUrl = API.COPY_LANGUAGE.replace("{{ botId }}", id).replace(
          "{{ language }}",
          action.language
        );

        return this.commonApiService.get<any>(fullUrl, {}).pipe(
          map((response) => {
            // this.alertService.alertSuccess(
            //   "Success!",
            //   "Language copied successfully",
            // );
            return copyLanguageSuccess({ response });
          }),
          catchError((error) => {
            return of(copyLanguageFailed({ error }));
          }),
        );
      }),
    );
  });

  private agentId(): string {
    const encrypted = sessionStorage.getItem("aiag");
    if (!encrypted) return "";
    return decryptData(encrypted || "");
  }
}
